document.addEventListener("DOMContentLoaded", function(){
  const container = document.querySelector(".product-list");
  const radios = document.querySelectorAll('input[name="filter.discount"]');
  const discountFilterGroup = document.querySelector(".filter-group--discount");
  const currentPath = window.location.pathname;

  // Helper: get disc from label
  const extractDiscount = el => {
    const lbl = el.querySelector(".product-label--sale:not(.product-label--clearance) span");
    const m = lbl && lbl.textContent.match(/(\d+)%/);
    return m ? parseInt(m[1]) : 0;
  };


  // Fungsi sortir produk
  const sortProducts = (direction = "desc") => {
    const items = Array.from(container.querySelectorAll(".product-block"));
    items.sort((a, b) => {
      const aVal = extractDiscount(a);
      const bVal = extractDiscount(b);
      return direction === "desc" ? bVal - aVal : aVal - bVal;
    });
    items.forEach(el => container.appendChild(el));
  };

  // 1.
 // ✅ run sorting DESC with condition:
  // - /collections/new-arrivals
  // - class filter discount
  if (currentPath !== "/collections/new-arrivals" && discountFilterGroup) {
    sortProducts("desc");

    const highRadio = document.querySelector('input[name="filter.discount"][value="desc"]');
    if (highRadio) highRadio.checked = true;
  }
  else {
    radios.forEach(r => r.checked = false);
  }
  // Set radio high as checked
  //const highRadio = document.querySelector('input[name="filter.discount"][value="desc"]');
  //if (highRadio) highRadio.checked = true;

  // 2. Event listener saat radio diklik
  radios.forEach(radio => {
    radio.addEventListener("change", () => {
      const value = radio.value;
      if (value === "desc") {
        sortProducts("desc"); // High
      } else {
        sortProducts("asc"); // Low
      }
    });
  });
});

